export type EmailFile = { id: string; filename: string; mimetype: string; size: number };

export type SentEmailRow = {
  id: string;
  sent_at: string;
  to: string;
  subject: string;
  kind: string;
  organization_id: string;
  organization_name: string;
  invoice_id: string | null;
  attachments: string[];
  files: EmailFile[];
  delivered: boolean;
  error: string;
  body_text?: string;
};

export const KIND_LABEL: Record<string, string> = {
  invoice: 'Invoice',
  invoice_reminder: 'Overdue reminder',
  approval_request: 'Approval request',
  approval_granted: 'Approval granted',
  support_message: 'Support message',
  offer_requested: 'Offer requested',
  verification: 'Sign-up code',
  other: 'Other',
};

export function kindLabel(kind: string) {
  return KIND_LABEL[kind] ?? (kind || 'Other');
}

export function when(value: string | null | undefined) {
  return value ? new Date(value).toLocaleString() : '';
}

export function onDay(value: string | null | undefined) {
  return value ? new Date(value).toLocaleDateString() : '';
}
